"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = Text;
exports.TextHighlight = TextHighlight;
exports.createFormitem = createFormitem;
exports.createInputboxClass = createInputboxClass;
exports.createInputboxLabel = void 0;
exports.default = Input;
exports.testIcon = testIcon;
var React = _interopRequireWildcard(require("react"));
var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));
var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _utils = require("../utils");
var _index = require("../index");
var _Form = require("./Form");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// ----- UTILS

function createInputboxClass(name, props) {
  var cls = (0, _utils.clsNames)('un-inputbox', name, !props.form && props.label && '-has-label', props.sm && 'un-inputbox-sm', props.lg && 'un-inputbox-lg', !props.m0 && 'un-boxmargin', props.className);
  var stateList = ['primary', 'secondary', 'success', 'info', 'warning', 'error', 'dark'];
  if (props.state) {
    if (stateList.indexOf(props.state) >= 0) cls += ' -' + props.state;
  }
  return cls;
}
var createInputboxLabel = function createInputboxLabel(label, focus, clsName) {
  return !!label && label !== true && /*#__PURE__*/React.createElement("label", {
    className: (0, _utils.clsNames)('un-inputbox-label', focus && '-focus', clsName)
  }, label);
};
exports.createInputboxLabel = createInputboxLabel;
function createFormitem(input, props, addProps) {
  var formProp = {};
  if (props.formProp) Object.assign(formProp, props.formProp);
  if (addProps) Object.assign(formProp, addProps);
  if (props.label) formProp.label = props.label;
  if (props.note) formProp.note = props.note;
  formProp.labelInput = true;
  return /*#__PURE__*/React.createElement(_Form.FormItem, _extends({}, formProp, {
    children: input
  }));
}
function testIcon(icon, def) {
  if (icon === true && !!def) return /*#__PURE__*/React.createElement(_Icon.default, {
    name: def
  });
  return typeof icon === 'string' ? /*#__PURE__*/React.createElement(_Icon.default, {
    name: icon
  }) : icon;
}

// ----- COMPONENT

function Input(props) {
  var label = props.label,
    inputRef = props.inputRef,
    value = props.value,
    defValue = props.defValue,
    readOnly = props.readOnly,
    multiline = props.multiline,
    center = props.center,
    right = props.right;
  var boxProps = {};

  // ----- EVENT

  var inputProp = {
    ref: inputRef,
    id: props.id,
    className: (0, _utils.clsNames)('un-inputbox-input', center && 'c', right && 'r', (value || defValue) && '-focus'),
    onFocus: props.onPress,
    onBlur: function onBlur(e) {
      return props.onBlur && props.onBlur(isNumber ? (0, _utils.num)(e.target.value) : e.target.value, e);
    }
  };
  var textProp = {};
  if (!!label) inputProp.placeholder = label;
  var isNumber = false;
  if (!multiline) {
    inputProp.type = props.type || 'text';
    isNumber = inputProp.type === 'number';
  } else if (typeof multiline === 'number') {
    inputProp.minRows = multiline;
  }
  if (value !== undefined || props.onChange !== undefined) {
    inputProp.value = (0, _utils.isEmpty)(value) ? '' : value;
  } else if (defValue !== undefined) {
    inputProp.defaultValue = (0, _utils.isEmpty)(defValue) ? '' : defValue;
  }
  if (readOnly) {
    boxProps.className = createInputboxClass((0, _utils.clsNames)('un-input-text', (value || defValue) && '-focus'), props);
    textProp.className = (0, _utils.clsNames)('un-inputbox-text', center && 'c', right && 'r');
    if (props.onClick) boxProps.onClick = props.onClick;
  } else {
    boxProps.className = createInputboxClass((0, _utils.clsNames)('un-input', (value || defValue) && '-focus'), props);

    /* เอาออกก่อน มีปัญหากับ InputSearch แล้วก็ไม่จำเป็นต้องใช้แล้ว เพราะ Unit ตอนนี้ ซ่อนได้แล้ว
    boxProps.onClick = (e: any) => {
        if (e.target && e.target.nodeName === 'SPAN' && e.currentTarget) {
            const inp = e.currentTarget.getElementsByTagName('INPUT')
            if (inp && inp.length > 0) inp[0].focus()
        }
    }*/

    if (!!props.onChange) {
      inputProp.onChange = function (e) {
        if (props.onChange) props.onChange(isNumber ? (0, _utils.num)(e.target.value) : e.target.value, e);
      };
      if ((0, _utils.isEmpty)(inputProp.value)) inputProp.value = '';
    } else if (props.onDelayChange) {
      var delayInput = (0, _index.clsDebounce)(function (value, e) {
        if (props.onDelayChange) props.onDelayChange(value, e);
      }, props.delay || 500);
      inputProp.onChange = function (e) {
        return delayInput(e.target.value, e);
      };
    }
    if (props.onPress || props.onPressEnter) {
      inputProp.onKeyPress = function (e) {
        if (e.key === 'Enter' && props.onPressEnter) {
          props.onPressEnter(e);
          e.preventDefault();
        }
        if (props.onPress) props.onPress(e);
      };
    }
    if (props.onFocus) inputProp.onFocus = props.onFocus;
  }

  // render

  var input = /*#__PURE__*/React.createElement("div", boxProps, (!!props.icon || !!props.prepend) && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, !!props.icon && testIcon(props.icon), !!props.prepend && (typeof props.prepend === 'string' ? /*#__PURE__*/React.createElement("span", {
    className: "un-inputbox-pend-text"
  }, props.prepend) : props.prepend)), /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-control"
  }, readOnly ? /*#__PURE__*/React.createElement("div", textProp, value || defValue) : props.multiline ? /*#__PURE__*/React.createElement(_reactTextareaAutosize.default, inputProp) : props.inputElement ? /*#__PURE__*/(0, React.cloneElement)(props.inputElement, inputProp) : /*#__PURE__*/React.createElement("input", inputProp), !props.form && !!props.label && createInputboxLabel(props.label)), (!!props.unit || !!props.apppend) && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-pend"
  }, !!props.unit && /*#__PURE__*/React.createElement("span", {
    className: "un-inputbox-pend-text -unit"
  }, props.unit), !!props.apppend && (typeof props.apppend === 'string' ? /*#__PURE__*/React.createElement("span", {
    className: "un-inputbox-pend-text"
  }, props.apppend) : props.apppend)), !props.form && !!props.note && /*#__PURE__*/React.createElement("div", {
    className: "un-inputbox-note"
  }, props.note), !!props.children && props.children);
  if (props.form) return createFormitem(input, props);
  if (typeof props.classBox === 'string') return /*#__PURE__*/React.createElement("div", {
    className: props.classBox
  }, input);
  return input;
}
function Text(props) {
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    onChange: function onChange() {},
    readOnly: true
  }));
}
function TextHighlight(props) {
  return /*#__PURE__*/React.createElement(_reactHighlightWords.default, {
    highlightClassName: props.classHighlight || 'red b',
    searchWords: Array.isArray(props.search) ? props.search : props.search.split(' '),
    textToHighlight: props.children
  });
}